import withErrorBoundary from '../ErrorBoundary';

import type { OppositeLegLinkProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './OppositeLegLink.module.scss';

const OppositeLegLink = (props: OppositeLegLinkProps) => {
  const { label } = props;

  return (
    <div
      className={STYLES.OppositeLegLink}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: label }}
    />
  );
};

const OppositeLegLinkWithErrorBoundary = withErrorBoundary(
  OppositeLegLink,
  'opposite-leg-link-component',
);
export default OppositeLegLinkWithErrorBoundary;
